import React, {Component} from 'react';
import {Table} from 'react-data-components';

const courses = [
    {
        course: 'MCAT',
        subject: 'Maths',
        title: 'Angelfish piranha alas hey much b',
        options: 'options',
        id: '000010'
    },
    {
        course: 'LSAT',
        subject: 'Physics',
        title: 'Justly away shaky re-laid including therefore m',
        options: 'options',
        id: '000020'
    },
    {
        course: 'GMAT',
        subject: 'Maths',
        title: 'Shrank less unlocked messy without bird hellish',
        options: 'options',
        id: '000030'
    },
    {
        course: 'GMAT',
        subject: 'Physics',
        title: 'Debating me breeding be answered an',
        options: 'options',
        id: '000040'
    },
    {
        course: 'MCAT',
        subject: 'Chemistry',
        title: 'His followed carriage proposal entrance',
        options: 'options',
        id: '000050'
    },
    {
        course: 'MCAT',
        subject: 'Chemistry',
        title: 'Literature admiration frequently indulgence',
        options: 'options',
        id: '000060'
    },
    {
        course: 'MCAT',
        subject: 'Physics',
        title: 'Mandrill insufferable ouc',
        options: 'options',
        id: '000070'
    },
    {
        course: 'GMAT',
        subject: 'Chemistry',
        title: 'More preparatory much derisively far impul',
        options: 'options',
        id: '000080'
    },
    {
        course: 'LSAT',
        subject: 'Chemistry',
        title: 'More preparatory much derisively fa',
        options: 'options',
        id: '000090'
    }
];

const questions = [
    {
        id: '0020201',
        title: 'Question',
        number: 1,
        description: '',
        removeQuestion: false,
        checkedOption: 'C',
        optionA: '',
        optionB: '',
        optionC: '',
        optionD: ''
    }
];

class StrategyModalCourseAdd extends Component {
    state = {
        columns: []
    };

    //Renders
    renderOptions = (val, row) => (
        <div className="dropdown">
            <a 
               data-toggle="dropdown"
               className="btn btn-default"
            >
                Options
            </a>
            <ul className="dropdown-menu pull-right">
                <li>
                    <a >
                        <i className="zmdi zmdi-copy"/> Copy Test
                    </a>
                </li>
                <li>
                    <a >
                        <i className="zmdi zmdi-edit"/> Edit Test
                    </a>
                </li>
                <li>
                    <a >
                        <i className="zmdi zmdi-plus-circle"/> Add Test
                    </a>
                </li>
                <li>
                    <a >
                        <i className="zmdi zmdi-delete"/> Delete
                    </a>
                </li>
            </ul>
        </div>
    );

    renderQuestions = (questions) => (
        questions.map((item) => (
            <div
                key={item.id}
                className="panel customPanel"
            >
                <div className="panel-heading border-bottom bg-light">
                    <div className="panel-control">
                        <a
                            
                            className="btn btn-danger"
                            // onclick="RemoveThisQuestion(this)"
                        >
                            <i className="zmdi zmdi-delete"/>
                        </a>
                    </div>
                    <h3 className="panel-title">
                        {item.title}
                        <span className="new_test_question_number">
                            {item.number}
                        </span>
                    </h3>
                </div>
                <div className="panel-body bg-light-2">
                    <div className="row">
                        <div className="col-sm-3">
                            <label>
                                <input
                                    type="checkbox"
                                    defaultChecked={item.removeQuestion}
                                />
                                Remove Question
                            </label>
                        </div>
                        <div className="col-sm-7">
                            <div className="row">
                                <div className="col-sm-3">
                                    <label>
                                        <input
                                            type="radio"
                                            name="option"
                                        />
                                        A
                                    </label>
                                </div>
                                <div className="col-sm-3">
                                    <label>
                                        <input
                                            type="radio"
                                            name="option"
                                        />
                                        B
                                    </label>
                                </div>
                                <div className="col-sm-3">
                                    <label>
                                        <input
                                            type="radio"
                                            name="option"
                                        />
                                        C
                                    </label>
                                </div>
                                <div className="col-sm-3">
                                    <label>
                                        <input
                                            type="radio"
                                            name="option"
                                        />
                                        D
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="sm-top10">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Description"
                                    defaultValue={item.description}
                                />
                            </div>
                            <div className="sm-top10">
                                <textarea
                                    className="form-control"
                                    rows="2"
                                    placeholder="Option A Explanation"
                                    defaultValue={item.optionA}
                                />
                            </div>
                            <div className="sm-top10">
                                <textarea
                                    className="form-control"
                                    rows="2"
                                    placeholder="Option B Explanation"
                                    defaultValue={item.optionB}
                                />
                            </div>
                            <div className="sm-top10">
                                <textarea
                                    className="form-control"
                                    rows="2"
                                    placeholder="Option C Explanation"
                                    defaultValue={item.optionC}
                                />
                            </div>
                            <div className="sm-top10">
                                <textarea
                                    className="form-control"
                                    rows="2"
                                    placeholder="Option D Explanation"
                                    defaultValue={item.optionD}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        ))
    );

    //Lifecycle
    componentDidMount() {
        this.setState({
            columns: [
                {title: 'Course', prop: 'course'},
                {title: 'Subject', prop: 'subject'},
                {title: 'Title', prop: 'title'},
                {title: 'Options', prop: 'options', render: this.renderOptions}
            ]
        })
    }
    render() {
        return (
            <div className="modal fade" id="AddStrategyModal" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel">
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-body no-padding">
                            <div className="nav-tabs-custom ">
                                <ul className="nav nav-tabs">
                                    <li className="active">
                                        <a href="#tab_11" data-toggle="tab">Saved Test</a>
                                    </li>
                                    <li>
                                        <a href="#tab_12" data-toggle="tab">New Test</a>
                                    </li>
                                </ul>
                                <div className="tab-content">
                                    <div className="tab-pane active no-padding" id="tab_11">
                                        <Table
                                            className="table table-bordered table-striped"
                                            keys="id"
                                            dataArray={courses}
                                            columns={this.state.columns}
                                        />
                                    </div>
                                    <div className="tab-pane" id="tab_12">
                                        <div className="form-group">
                                            <div className="row">
                                                <div className="col-sm-6">
                                                    <div className="form-group">
                                                        <label>Course</label>
                                                        <select className="form-control">
                                                            <option value="">Choose</option>
                                                            <option value="">LSAT</option>
                                                            <option value="">GMAT</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-sm-6">
                                                    <div className="form-group">
                                                        <label>Subject</label>
                                                        <select className="form-control">
                                                            <option value="">Choose</option>
                                                            <option value="">Physics</option>
                                                            <option value="">Chemistry</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-sm-8">
                                                    <div className="form-group">
                                                        <label>Title</label>
                                                        <input type="text" className="form-control"/>
                                                    </div>
                                                </div>
                                                <div className="col-sm-4">
                                                    <div className="form-group">
                                                        <label>Answer Choices</label>
                                                        <select className="form-control">
                                                            <option value="">4</option>
                                                            <option value="">5</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="AddNewTestQuestiosModalWrapper">
                                                <div className="duplicateablequestion">
                                                    {this.renderQuestions(questions)}
                                                </div>
                                            </div>
                                            <a
                                                
                                                className="btn btn-block btn-info"
                                                // onclick="AddMoreQuestionToTheTest(this)"
                                            >
                                                <i className="zmdi zmdi-plus-circle"/>
                                                Add Another Question
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-default" data-dismiss="modal">Close</button>
                            <button type="button" className="btn btn-primary">Save changes</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default StrategyModalCourseAdd;


// WEBPACK FOOTER //
// ./src/components/AdminPanel/Strategy/StrategyModalCourseAdd.js